// Reusable documentation blocks about the Super Secretary flag (CAM-1533).
// Body item types are described in ../README.md.
export default [
  {
    id: 'secretaries.super.what',
    title: 'What is a Super Secretary?',
    body: [
      { p: 'A Super Secretary is an existing Secretary (either a Member Secretary or Secretary Only) who has been granted additional access by an admin.' },
      { p: 'Super Secretary is not a separate user role. It is an additional permission that allows selected secretaries to work across multiple committees without changing their existing permissions or functionality.' }
    ]
  },
  {
    id: 'secretaries.super.why',
    title: 'Why is it needed?',
    body: [
      { p: 'ACA occasionally requires secretaries to provide support for other committees, particularly on weekends. Instead of creating additional accounts, Super Secretaries can log in with their own credentials and switch between committees as needed. This eliminates the need for temporary accounts or shared login credentials, improves security, and ensures that actions can be traced back to the person who performed them.' }
    ]
  },
  {
    id: 'secretaries.super.how',
    title: 'How does it work?',
    body: [
      {
        ul: [
          'A Super Secretary retains full access to their own committee, along with their existing Member functionality.',
          'A new **Switch Committee** option appears in the left-hand menu, allowing them to select another committee to work with without accessing other secretaries\' accounts, personal details, or passwords.',
          'Only **financial** committees are available for selection.',
          'When working with another committee, a yellow notification bar appears at the top of the page, showing which committee is currently selected.',
          'Super Secretaries can manage the selected committee\'s nominations, drafts, draws, and reports. However, the **Committee** page is read-only, so they can view committee details but cannot make changes.'
        ]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/docs/blocks/secretaries.js